import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import Header from "./components/header.jsx"
import Navbar from "./components/navbar.jsx"

import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
} from "react-router-dom";

import Home from './routes/home';
import Accessions from './routes/accessions';
import Graph from './routes/graph';
import Pangenome from './routes/pangenome';
import Diamond from './routes/diamond';
import Sequences from './routes/sequences';
import Variants from './routes/variants';
import Map from './routes/map';
import About from './routes/about';

import NotFound from './routes/not_found';

function NavbarWrapper() {
    return (
    <div>
        <Navbar/>
        <Outlet/>
    </div>
    )
};

// const basename = document.querySelector('base')?.getAttribute('href') ?? '/';
const basename = "/1001G+/resource_center/";
const router = createBrowserRouter(
[
  {
    path: "/", 
    element: <NavbarWrapper />,
    errorElement: <NotFound />,
    children: [
      {
         path: "/", // yes, again
         element: <Home />
      },
      {
         path: "/home",
         element: <Home />
      },
      {
         path: "//accessions",
         element: <Accessions />
      },
      {
         path: "/graph",
         element: <Graph />
      },
      {
         path: "/pangenome",
         element: <Pangenome />
      },
      {
         path: "/diamond",
         element: <Diamond />
      },
      {
         path: "/sequences",
         element: <Sequences />
      },
      {
         path: "/variants",
         element: <Variants />
      },
      {
         path: "/map",
         element: <Map />
      },
      {
         path: "/about",
         element: <About />
      },
    ]
  }
],
{
  basename: basename,
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Header />
    <RouterProvider router={router} />
  </React.StrictMode>
);
